module.exports = __webpack_public_path__ + "static/media/computing_logo.76401d59.png";